"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var ActiveBonusCard_1 = __importDefault(require("./ActiveBonusCard"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ActiveBonuses = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder, activeCashBonus = _a.activeCashBonus, cancelBonusHandler = _a.cancelBonusHandler, activeFreespins = _a.activeFreespins, cancelFreespinsHandler = _a.cancelFreespinsHandler;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.activeBonusesWrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.typeBonus }, t('activeBonus')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.activeBonusesContainer },
            activeCashBonus && react_1.default.createElement(ActiveBonusCard_1.default, { bonus: activeCashBonus }),
            activeFreespins && (react_1.default.createElement(ActiveBonusCard_1.default, { fsBonus: activeFreespins, gameCardPlaceholder: gameCardPlaceholder })))));
};
exports.default = ActiveBonuses;
